<template> 
    <aside :id="!right ? 'right-sidebar' : 'sidebar-left'" :style="widthChanger"
    style="transition: none; margin-right: 50px; background-color: #323e44;" 
    class="table-resize-reset sup-resize-stop resize-stop"
    :class="[!right ? 'control-sidebar control-sidebar-dark wtree_right' : 'main-sidebar pull-left sidebar-primary wtree_left']">
      <!-- sidebar: style can be found in sidebar.less -->
      <section class="sidebar" style="padding: 0px;" :style="'margin-left:' + (!right ? '0px' : '50px') +';'">
          <!-- Sidebar Menu and Search Menu-->
          <li id="buttons.sup_resize_wrapper" class="header"
                  :style="'z-index: 9999; list-style: none; color: #999; padding: 0px; margin-bottom: 2px; position: absolute;'+ pos_string">
                      
                      <!-- pulsante di resize allineato a sinistra-->
                      <dynButton v-if="right" :configs="{ID: 'buttons.sup-resize', visible: true}"
                      btnClasses="sup-resize-start" :icon="$root.icons.h_resize"
                      @invisible="hide('buttons.sup_resize_wrapper')"
                      :styleObj="{
                          'border-width':'2px', 
                          'border-color':'#999',
                          'position':'fixed', 'top': '57px',
                          'width': '28px', 'height': '30px', 'padding': '1px', 'float': 'right', 
                          'cursor': 'w-resize', 'background-color': '#666', 'color': 'white'}"></dynButton>

                      <!-- pulsante di resize allineato a destra-->
                      <div v-if="!right" class="right-btn-wrapper" style="position: fixed; top: 50px;">
                          <dynButton :configs="{ID: 'buttons.sup-resize', visible: true}"
                          btnClasses="sup-resize-start" :icon="$root.icons.h_resize"
                          @invisible="hide('buttons.sup_resize_wrapper')"
                          :styleObj="{
                              'border-width':'2px', 
                              'border-color':'#999',
                              'position':'absolute',
                              'width': '28px', 'height': '30px', 'padding': '1px', 'float': 'right', 'top': '7px',
                              'cursor': 'w-resize', 'background-color': '#666', 'color': 'white'}"></dynButton>
                      </div>
                  </li>
          <!-- /.sidebar-menu and ./search-menu-->
      </section>
      <!-- /.sidebar  -->

      <div v-if="content == 'Impiego'" style="text-align: center; padding: 1px 0px; border-bottom: 1px solid rgb(173, 180, 187); box-shadow: rgb(243, 253, 255) 0px 1px 0px; color: #323e44 !important"> <!--border-bottom: 1px solid rgb(9, 12, 15); box-shadow: rgb(80, 94, 101) 0px 1px 0px;-->
        <label style="padding-top: 8px; text-align: center;">{{$Jed.firstUpperTranslate('use')}}</label>
      </div>
      <div v-if="content == 'Documenti'" style="text-align: center; padding: 1px 0px; border-bottom: 1px solid rgb(173, 180, 187); box-shadow: rgb(243, 253, 255) 0px 1px 0px; color: #323e44 !important">
        <label style="padding-top: 8px; text-align: center;">{{$Jed.firstUpperTranslate('document', 2)}}</label>
      </div>
      <div v-if="content == 'Anteprime'" style="text-align: center; padding: 1px 0px; border-bottom: 1px solid rgb(173, 180, 187); box-shadow: rgb(243, 253, 255) 0px 1px 0px; color: #323e44 !important">
        <label style="padding-top: 8px; text-align: center;">{{$Jed.firstUpperTranslate('preview', 2)}}</label>
      </div>
       <!-- header tabs attivi per tutto tranne Stampa-->
       <div v-if="content != 'Stampa'" class="media" style="margin: 0px;">
        <div class="media-body media-middle" style="height: 80px; display: inline;">
          <ul class="sidebar-menu"> 
              <li class="header" 
              style="color: #999; padding: 0px; margin: 0px; background-color:inherit; display: list-item; text-align: center; border-bottom: none" >
                  <form class="sidebar-form row" style="border-style: none; display: block;">
                      <div v-if="activeComponent == 'Impiego' && $root.richiestaImpiego" class="col-xs-12 sidebar-text" style="padding: 0px; font-size: larger;">
                          <ul class="nav nav-pills f-s">
                            <li class="active" style="float: none; width: 100%; padding: 0px;"><a class="f-s-a" href="#">
                              <span>{{($root.richiestaImpiego.spi && $root.richiestaImpiego.spi != "" ? $root.richiestaImpiego.spi : $root.richiestaImpiego.cod) + ' - '}}</span>{{$root.richiestaImpiego.des}}</a></li>
                          </ul>
                      </div>
                      <div v-else class="col-xs-12 sidebar-text" style="padding: 0px; font-size: larger;">
                        <ul v-if="trigger == null || trigger.length == 0" class="nav nav-pills f-s">
                          <li v-if="activeData && activeData.father" class="active" style="float: none; width: 100%; padding: 0px;"><a class="f-s-a" href="#"><span>{{activeData.father.sid + ' - '}}</span>{{activeData.father.des}}</a></li>
                        </ul>
                        <ul v-else class="nav nav-pills f-s">
                          <li :class="{'active': activeTab == 'father'}" style="float: right; width: 100%; padding: 0px;"><a class="f-s-a" href="#" @click.prevent="toggleFather"><span>{{activeData.father.sid + ' - '}}</span>{{activeData.father.des}}</a></li>
                          
                          <li v-for="(child, index) in trigger" :key="index" :class="{'active': activeTab == 'child' && activeChild == index}" style="float: right;" :style="{width: trigger_width}" >
                            <a class="f-s-a" href="#" @click.prevent="toggleChild(index)"><span>{{child.sid + ' - '}}</span>{{child.des}}</a>
                          </li>
                        </ul>
                      </div>
                  </form>
              
              </li>
          </ul>
        </div>
      </div>

      <components :is="activeComponent" :activeData="activePropData" :mh="maxHeight" :isChild="activeTab == 'child'"></components>
       
    </aside>
</template>
<script>
import dynButton from "./dynamic/DynButton.vue";
import { eventBus } from "../eventbus.js";

import Anteprime from "./menu-sup-components/Anteprime.vue"
import Impiego from "./menu-sup-components/Impiego.vue"
import Documenti from "./menu-sup-components/Documenti.vue"
import Stampa from "./menu-sup-components/Stampa.vue"

// setMaxHeight monitora l'altezza massima del contenuto della sidebar, per adattarla al massimo consentito
var vi;

export default {
  props: {
    right: {
      type: Boolean,
      default: false
    },
    content: String
  },
  components: {
    dynButton,
    Anteprime,
    Impiego,
    Documenti,
    Stampa
  },
  watch: {
    "$route.params.focus": function() {
      //quando cambia il parametro nell'url (ho cliccato <- nel browser)
      this.focusDetect();
    },
    content: function(){
      if(this.content == "Stampa"){
        //Stampa attiva sempre e solo per l'elemento padre (disegno)
        this.toggleFather();
      }
      this.activeComponent = this.content;
    }
  },
  data: function() {
    var vi = this;
    return {
      pos_string: !this.right ? "left: 0px" : "right: 28px",
      target: null,
      activeData: null,
      activePropData: null,

      componentsSwitch: [
        {text: vi.$Jed.firstUpperTranslate('preview', 2), comp: "Anteprime"},
        {text: vi.$Jed.firstUpperTranslate('use', null), comp: "Impiego"},
        {text: vi.$Jed.firstUpperTranslate('document', 2), comp: "Documenti"}],
      activeComponent: null,
      maxHeight: null,
      
      activeTab: "father",
      activeChild: 0,
      trigger: [],
      trigger_width: "100%"
    };
  },
  mounted: function(){
    try {
      if((this.$route.name == "wrapper" || this.$route.name == "wrapper_focus") && this.$route.params.id != null){
        this.target = this.$route.params.id;
        this.$nextTick(function(){
            this.$root.attachSupportListeners()
            this.activeComponent = this.content;
            this.init();
        })
      } else {
        this.$emit("closeme")
      }
    } catch(err){this.$emit("closeme")}
  },
  created: function(){
    var vm = this;
    eventBus.$on("detail_changed", () => {
      vm.$root.showOnlyImg = false;
      vm.$root.styleSupportSidebarIcons();
      if(vm.$route.params.focus != null){
        vm.activeTab = "child";
      }
      vm.init();
    });
    eventBus.$on("heightMutation", function(){
      vm.$nextTick(function(){
        vm.setMaxHeight();
      })
    });
  },
  beforeDestroy: function(){
    if (!this.right) {
      if( $(".content-wrapper").css("margin-right") != "0px" )
        $(".content-wrapper").css("margin-right", 50);
    } else {
      if( $(".content-wrapper").css("margin-left") != "0px" )
        $(".content-wrapper").css("margin-left", 50);
    } 
  },
  computed: {
    widthChanger: function() {
        if (!this.right) {
          var vm = this;  
          $(".content-wrapper").css("margin-right", 350);
          return "width: 350px;";
        } else {
          $(".content-wrapper").css("margin-left", 350);
          return "width: 350px;";
        };
    }
  },
  methods: {
    init: function() {
      this.activeData = this.$store.getters.getActive;
      console.log("get active data: ", this.activeData)
      this.focusDetect();
      this.setMaxHeight();
    },
    focusDetect: function(){
            
      if(this.$route.params.focus){
        this.trigger = [];
        var serials = []
        this.trigger = this.activeData.children.filter(function(child){
          if(child[this.$Behaviors.focusBy()] == this.$route.params.focus){
            var found = serials.indexOf(child.sid);
            if(found == -1){
              serials.push(child.sid)
              return true;
            } 
          }
          return false;
        }, this)
        if(this.trigger.length == 0 ){
          this.activePropData = this.activeData
        } else {
          if(this.activeComponent != "Stampa"){
            this.toggleChild(0);
            this.trigger_width = Math.floor(100 / this.trigger.length) + "%";
          }
        }
      } else {
        this.trigger = [];
        this.activePropData = this.activeData;
      }

    },
    setMaxHeight: function(){
      //nabar - sidebar header - sidebar tabs - container margin
      if(this.$root.WINDOW_HEIGHT != null){
        this.maxHeight = this.$root.WINDOW_HEIGHT - (55 + 55 + 32 + 10);
      }
    },
    toggleFather: function(){
      if(this.activeTab != "father"){
        this.activePropData = this.activeData
        this.activeTab = "father";
        //this.activeComponent = "Anteprime";
      }
    },
    toggleChild: function(index){
      this.activePropData = {father: this.trigger[index]};
      this.activeTab = "child";
      this.activeChild = index;
    }
  }
}
</script>
<style scoped>

ul.nav.nav-pills {
  float: right;
}

ul.nav.nav-pills a {
  border-style: none;
  color: #b8c7ce;
  padding: 5px 10px;
  font-weight: 400;
  border-radius: 2px;
}

ul.nav.nav-pills a:hover {
  background-color: #b8c7ce;
  color: #323e44;
}

ul.nav.nav-pills > li.active > a, ul.nav.nav-pills > li.active > a:hover {
  background-color: #337ab7;
  color: white;
}

ul.f-s {
  padding-top: 0px;
  width: 100%;
}

ul.f-s > li {
  margin-left: 0px;
  width: 50%;
}

a.f-s-a {
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

aside.control-sidebar {
  min-height: 100%;
  z-index: 810;
}

#right-sidebar {
  right: 0px;
}

.fade-roll-enter {
  opacity: 0;
}

.fade-roll-enter-active {
  animation: slide-in 0.3s ease-out forwards;
  transition: opacity 0.3s;
}

.fade-roll-leave-active {
  animation: slide-out 0.3s ease-out forwards;
  transition: opacity 0.3s;
  opacity: 0;
}

@keyframes slide-in {
  from {
    transform: translateX(-100px);
  }
  to {
    transform: translateX(0px);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-100px);
  }
}

.sx {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.dx {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.input-group input {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}

.full {
  border-top-style: solid;
  border-width: thin;
  border-color: #444;
}

.noBorder {
  border-style: none;
}

.control-sidebar {
  -webkit-transition: -webkit-transform 0.3s ease-in-out, width 0.3s ease-in-out;
  -moz-transition: -moz-transform 0.3s ease-in-out, width 0.3s ease-in-out;
  -o-transition: -o-transform 0.3s ease-in-out, width 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
}
</style>

<style>
ul.nav.nav-tabs.sup-tabs a {
  background-color: #b8c7ce;
  color: #323e44;
  //padding: 5px 10px;
  padding: 1px 5px;
}

ul.nav.nav-tabs.sup-tabs > li.active > a {
  background-color: #323e44;
  color: #b8c7ce;
}
</style>


// WEBPACK FOOTER //
// src/components/SupportSidebar.vue?60950880